
export const Stage = {
  IDLE: 'idle',
  QUERY: 'querying',
  QUERYSTAGE: 'querying done',
  PROCESSING: 'processing',
  PROCESSINGSTAGE: 'processing done',
  CREATE: 'creating geometry',
  CREATED: 'creating done',
  LOADING: 'loading',
  DONE: 'done',
  ERROR: 'error',
  NULL:'null',
  TIMEDOUT: "Timed out"

};

export const GeometryType = {
  SITE_PLOTS: 'sitePlots',
  BUILDINGS: 'buildings',
  TOPOGRAPHY: 'topography',
  RISKAREA: 'riskarea',
  LANDUSE:'landuse',
  BPLAN:'bplan'
};